export default __webpack_public_path__ + "static/media/gear_1.17246fc3.svg";